import HomePage from "@/views/HomePage.vue";
import Account from "@/views/Account.vue";
import Wallet from "@/views/Wallet.vue";
import Exchange from "@/views/Exchange.vue";
import Settings from "@/views/Settings.vue";
import Api from "@/views/Api.vue";
import Login from "@/views/Login.vue";
import Signup from "@/views/Signup.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import ResetPassword from "@/views/ResetPassword.vue";
import ResetPasswordInternal from "@/views/ResetPasswordInternal.vue";

import { createRouter, createWebHistory } from "vue-router";
import { h, resolveComponent } from "vue";
import store from "@/store/store.js";
import { mdiConsoleNetworkOutline } from "@mdi/js";
import Auth2fa from "../views/Auth2fa.vue";
import Auth2faDeActivate from "../views/Auth2faDeActivate.vue";
import Auth2faActivate from "../views/Auth2faActivate.vue";
import Tickets from "../views/Tickets.vue";
import Subscription from "../views/Subscription.vue";
import Plan from "../views/Plan.vue";
import Payment from "../views/Payment.vue";
import Collections from "../views/Collections.vue";
import CollectionsNFT from "../views/CollectionsNFT.vue";
import Billing from "../views/Billing.vue";
import Statistics from "../views/Statistics.vue";
import Ticketing from "../views/Ticketing.vue";
import Messages from "../views/Messages.vue";
import NFT from "../views/NFT.vue";

const routes = [
  {
    path: "/",
    component: {
      render() {
        return h(resolveComponent("router-view"));
      },
    },
    meta: {
      title: "Muzible",
      metaTags: [
        {
          name: "description",
          content: "Muzible",
        },
        {
          property: "og:description",
          content: "Muzible",
        },
      ],
    },
    children: [
      {
        path: "",
        name: "muzible",
        component: HomePage, // Login/Reg Screen only for not logged users, when user is logged and has some queryparam set redirect to that page
        meta: {
          title: "Muzible",
          metaTags: [
            {
              name: "Muzible",
              content: "Muzible - Solutions for Artists",
            },
            {
              property: "og:Muzible",
              content: "Muzible - Solutions for Artists",
            },
          ],
        },
      },
      {
        path: "/logout",
        name: "logout",
      },
      {
        path: "/app",
        name: "app",
        component: HomePage, // Login/Reg Screen only for not logged users, when user is logged and has some queryparam set redirect to that page
        meta: {
          title: "Muzible",
          metaTags: [
            {
              name: "Muzible",
              content: "Muzible - Solutions for Artists",
            },
            {
              property: "og:Muzible",
              content: "Muzible - Solutions for Artists",
            },
          ],
        },
      },
      {
        path: "/login",
        name: "login",
        component: Login, // Login/Reg Screen only for not logged users, when user is logged and has some queryparam set redirect to that page
        meta: {
          title: "Muzible Login",
          metaTags: [
            {
              name: "Muzible",
              content: "Muzible - Solutions for Artists",
            },
            {
              property: "og:Muzible",
              content: "Muzible - Solutions for Artists",
            },
          ],
        },
      },
      {
        path: "/auth2fa",
        name: "auth2fa",
        component: Auth2fa, // Login/Reg Screen only for not logged users, when user is logged and has some queryparam set redirect to that page
        meta: {
          title: "Muzible Login",
          metaTags: [
            {
              name: "Muzible",
              content: "Muzible - Solutions for Artists",
            },
            {
              property: "og:Muzible",
              content: "Muzible - Solutions for Artists",
            },
          ],
        },
      },
      {
        path: "/forgot",
        name: "forgot",
        component: ForgotPassword, // Login/Reg Screen only for not logged users, when user is logged and has some queryparam set redirect to that page
        meta: {
          title: "Muzible Forgot Password",
          metaTags: [
            {
              name: "Muzible Forgot Password",
              content: "Muzible Forgot Password",
            },
            {
              property: "og:Muzible Forgot Password",
              content: "Muzible Forgot Password",
            },
          ],
        },
      },
      {
        path: "/reset/:token",
        name: "reset",
        props: true,
        component: ResetPassword,
        meta: {
          title: "Muzible Reset Password",
          metaTags: [
            {
              name: "Muzible Reset Password",
              content: "Muzible Reset Password",
            },
            {
              property: "og:Muzible Reset Password",
              content: "Muzible Reset Password",
            },
          ],
        },
      },
      {
        path: "/resetinternal/:token",
        name: "resetinternal",
        props: true,
        component: ResetPasswordInternal,
        meta: {
          title: "Muzible Reset Password",
          metaTags: [
            {
              name: "Muzible Reset Password",
              content: "Muzible Reset Password",
            },
            {
              property: "og:Muzible Reset Password",
              content: "Muzible Reset Password",
            },
          ],
        },
      },
      {
        path: 'unsubscribe/:uid', 
        name: "Unsubscribe",
        props: true,
        component: HomePage,
        meta: {
          title: 'Muzible',
          metaTags: [
            {
              name: 'Muzible',
              content: 'Muzible'
            },
            {
              property: 'og:Muzible',
              content: 'Muzible'
            }
          ]
        }
      },  
      {
        path: "/signup",
        name: "signup",
        component: Signup, // Login/Reg Screen only for not logged users, when user is logged and has some queryparam set redirect to that page
        meta: {
          title: "Muzible Sign up",
          metaTags: [
            {
              name: "Muzible",
              content: "Muzible - Solutions for Artists",
            },
            {
              property: "og:Muzible",
              content: "Muzible - Solutions for Artists",
            },
          ],
        },
      },
      {
        path: "/acc",
        meta: {
          title: "Account",
          metaTags: [
            {
              name: "Muzible Account",
              content: "Muzible Account. ",
            },
            {
              property: "og:Muzible Account",
              content: "Muzible Account. ",
            },
          ],
        },
        children: [
          {
            path: "",
            name: "account",
            component: Account,
            meta: {
              title: "Account",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Account",
                  content: "Muzible Account",
                },
                {
                  property: "og:Muzible Account",
                  content: "Muzible Account",
                },
              ],
            },
          },
          {
            path: "billing",
            name: "billing",
            component: Billing,
            meta: {
              title: "Billing",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Billing",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Billing",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "ticketing",
            name: "ticketing",
            component: Ticketing,
            meta: {
              title: "Ticketing",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Ticketing",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Ticketing",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "statistics",
            name: "statistics",
            component: Statistics,
            meta: {
              title: "Statistics",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Statistics",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Statistics",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "collections",
            name: "collections",
            component: Collections,
            meta: {
              title: "Collections",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Collections",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Collections",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "nftcollection",
            name: "nftcollection",
            component: CollectionsNFT,
            meta: {
              title: "NFT",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible NFT",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible NFT",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "payment",
            name: "payment",
            component: Payment,
            meta: {
              title: "Payment",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Payment",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Payment",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
            children: [
              { 
                path: 'success', 
                name: "main_success",
                component: Payment,
                meta: {
                  title: 'Muzible Payment',
                  metaTags: [
                    {
                      name: "Muzible Payment",
                      content: "Muzible - Solutions for Artists",
                    },
                    {
                      property: "og:Muzible Payment",
                      content: "Muzible - Solutions for Artists",
                    },
                  ]
                }
              }
            ],
          },
          {
            path: "plan",
            name: "plan",
            component: Plan,
            meta: {
              title: "Plan",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Your Plan",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Your Plan",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "subscription",
            name: "subscription",
            component: Subscription,
            meta: {
              title: "Subscription",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible subscription",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible subscription",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "tickets",
            name: "tickets",
            component: Tickets,
            meta: {
              title: "Tickets",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Tickets",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Tickets",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "wallet",
            name: "wallet",
            component: Wallet,
            meta: {
              title: "Wallet",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Wallet",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Wallet",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "enable2fa",
            name: "enable2fa",
            component: Auth2faActivate,
            meta: {
              title: "Enable 2FA",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible - Enable 2FA",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible - Enable 2FA",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "disable2fa",
            name: "disable2fa",
            component: Auth2faDeActivate,
            meta: {
              title: "Disable 2FA",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible - Disable 2FA",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible - Disable 2FA",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "messenger",
            name: "messenger",
            component: Messages,
            meta: {
              title: "Messenger",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Messenger",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Messenger",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "nft",
            name: "nft",
            component: NFT,
            meta: {
              title: "NFT",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible NFT Market",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible NFT Market",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "exchange",
            name: "exchange",
            component: Exchange,
            meta: {
              title: "Exchange",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Exchange",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Exchange",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "settings",
            name: "settings",
            component: Settings,
            meta: {
              title: "Settings",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible Settings",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible Settings",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
          {
            path: "api",
            name: "api",
            component: Api,
            meta: {
              title: "API",
              requiresAuth: true,
              metaTags: [
                {
                  name: "Muzible API",
                  content: "Muzible - Solutions for Artists",
                },
                {
                  property: "og:Muzible API",
                  content: "Muzible - Solutions for Artists",
                },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return { left: 0, top: 0 };
  },
});

router.beforeEach((to, from, next) => {

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.getters.getUserData === null) {

      const userStringLS = localStorage.getItem("user-muzible");
      if (userStringLS) {
        const userDataLS = JSON.parse(userStringLS);
        store.dispatch("checkJWTValid", userDataLS).then(({ data }) => {
          if (data.jwtinvalid === 1) {
            store.dispatch("logout");
        } else {
            store.commit("SET_USER_DATA_LS", userDataLS);
            store.commit("SET_COOKIES", userDataLS);
              next({ name: to.name})
          }
        })
        .catch((error) => {
          if (!error.response) {
            store.dispatch("logout");
          }
        });
      } else {
        next({ name: "muzible" });
      }
    } else {
      next(); // go
    }
  } else {
    if (store.getters.getUserData === null) {
      if (to.name !== "logout") {
        next(); // go and show Login/Reg page
      } else {
        store.dispatch("logout");
      }
    } else {
      if (to.name === "muzible" || to.name === "app") {
        if (
          Object.prototype.hasOwnProperty.call(to.query, "muze") &&
          to.query.muze === "1"
        ) {
          window.location.href = "https://muze.muzible.com";
        } else if (
          Object.prototype.hasOwnProperty.call(to.query, "tickets") &&
          to.query.tickets === "1"
        ) {
          window.location.href = "https://tickets.muzible.com";
        } else if (
          Object.prototype.hasOwnProperty.call(to.query, "shop") &&
          to.query.shop === "1"
        ) {
          window.location.href = "https://shop.muzible.com";
        } else if (
          Object.prototype.hasOwnProperty.call(to.query, "nft") &&
          to.query.nft === "1"
        ) {
          window.location.href = "https://verse.muzible.com";
        } else {
          next({ name: "plan" }); // logged and want to go to muzible or app redirect to Account
        }
      } else {
        if (to.name === "logout") {
          store.dispatch("logout");
        } else if (to.name === "login") {
          next({ name: "plan" });
        } else if (to.name === "signup") {
          next({ name: "plan" });
        } else {
          next();
        }
      }
    }
  }
});

export default router;
